<template>
  <ul class="service-btn-picker-wrapper">
    <li
      :class="['btn-item', item.isActive ? 'active' : '']"
      v-for="(item, index) in items"
      :style="{ transform: 'translateX(-' + index + 'px)' }"
      @click="onClickItem(item)"
    >
      {{item.name}}
    </li>
  </ul>
</template>

<script>
import defaultAvatar from '../../assets/default_avatar.png'

export default {
  name: 'BtnPicker',
  props: {
    items: Array,
  },
  methods: {
    onClickItem(item) {
      this.$emit('on-change-date', item)
    },
  },
};
</script>

<style scoped lang="scss">
.service-btn-picker-wrapper {
  display: inline-flex;
  margin: 0;
  padding: 0;
  list-style: none;

  .btn-item {
    font-size: 14px;
    line-height: 24px;
    padding: 0 6px;
    border: 1px solid #d9d9d9;
    transform: rotateX(-1px);

    &:first-child {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    &:last-child {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    &.active {
      border-color: #e51c23;
      color: #e51c23;
      z-index: 1;
    }
  }
}
</style>
